/* Safra product gallery: thumbnails swap the main image; arrows + swipe.
   v4.8 sweep (2026-10-22): the swap keeps a responsive srcset (thumbs carry data-srcset), so phones fetch the
   800px file instead of the 1600px one; the next image is decoded before it is shown (no flash of the old one
   at the new size); left / right arrow keys work while the gallery has focus; thumbs expose aria-pressed. */
if (!customElements.get('sf-gallery')) {
  class SfGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-main]');
      this.frame = this.querySelector('.sf-pdp__main');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.index = 0;
      this.token = 0;
      if (!this.main || !this.frame) return;
      this.sizes = this.main.getAttribute('sizes') || '';
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.show(this.index - 1));
      if (next) next.addEventListener('click', () => this.show(this.index + 1));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + 1); }
      });
      let x0 = null;
      let y0 = null;
      this.frame.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      this.frame.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        /* A mostly-horizontal swipe only; a vertical drag is a scroll. */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
        x0 = null;
        y0 = null;
      }, { passive: true });
    }

    show(i) {
      if (!this.thumbs.length) return;
      const n = this.thumbs.length;
      const idx = ((i % n) + n) % n;
      if (idx === this.index && this.main.dataset.sfShown === String(idx)) return;
      this.index = idx;
      const t = this.thumbs[idx];
      const token = ++this.token;
      this.frame.classList.add('is-switching');
      this.thumbs.forEach((el, k) => {
        const on = k === idx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const img = new Image();
      if (t.dataset.srcset) {
        img.srcset = t.dataset.srcset;
        if (this.sizes) img.sizes = this.sizes;
      }
      img.src = t.dataset.src;
      const apply = () => {
        if (token !== this.token) return; /* a later click won */
        if (t.dataset.srcset) {
          this.main.srcset = t.dataset.srcset;
          if (this.sizes) this.main.sizes = this.sizes;
        } else {
          this.main.removeAttribute('srcset');
          this.main.removeAttribute('sizes');
        }
        this.main.src = t.dataset.src;
        this.main.alt = t.dataset.alt || '';
        this.main.dataset.sfShown = String(idx);
        this.frame.classList.remove('is-switching');
      };
      /* Wait for the load, not for decode(): decode() can sit unresolved in a background tab, which would leave
         the frame dimmed. The file is in cache by then, so the swap itself is instant. */
      const ready = new Promise((r) => {
        img.onload = r;
        img.onerror = r;
        if (img.complete && img.naturalWidth) r();
      });
      ready.then(apply);
      t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }
  customElements.define('sf-gallery', SfGallery);
}
